import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../base/Checkbox';

import styles from './Select.scss';
import withTranslations from '../../utils/Translations/withTranslations';
import translatePropTypes from '../../../translatePropTypes';

@withTranslations
export default class MultiselectSelectAllItem extends React.PureComponent {
  static propTypes = {
    allSelected: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    ...translatePropTypes,
  };

  handleToggle = () => {
    const { allSelected, onToggle } = this.props;
    onToggle(!allSelected);
  };

  render() {
    const { allSelected, t } = this.props;

    const listItemClassName = allSelected ? 'active' : null;
    const checkboxClassName = allSelected ? styles.selectedItem : null;

    return (
      <li className={listItemClassName}>
        <Checkbox
          className={checkboxClassName}
          label={t('Select All')}
          value={allSelected}
          onChange={this.handleToggle}
        />
      </li>
    );
  }
}
